import React from 'react'
import style from './Navbar.module.css'
import { option1 } from '../../Const'
function Navbar() {
   
    return (
    <nav className={style.grandparent}>
      <div className={style.header}>
      {option1.map((item,i)=>{
        return(
            <div className={style.firsticons} key={i}>
            {item}</div>
        )
      })}
       
      </div>
    </nav>
  )
}

export default Navbar
